import { UserProfileToEditVM } from "../interfaces/User";
import BaseApi from "./BaseApi";
const baseUrl = 'api/user/';

type AutoCompleteResponse = {
    Id: string;
    FullName: string;
    Email?: string;
    Document?: string;
    Phone?: string;
    PostalCode?: string;
    Street?: string;
    City?: string;
    State?: string;
    StreetNumber?: string;
    Complement?: string;
    District?: string;
}

class UserService {

    static post(request: any) {
        return BaseApi.post(`api/account`, request);
    }

    static postNew(request: any) {
        return BaseApi.post(`${baseUrl}`, request);
    }

    static postConfirmUser(request: any) {
        return BaseApi.post(`api/account/confirm`, request);
    }

    static putApprovalProcessPersonal(request: any) {
        return BaseApi.put(`${baseUrl}approval-process/personal`, request);
    }

    static postConfirmEmail(request: any) {
        return BaseApi.post(`api/account/confirm-email`, request);
    }

    static putSocialNetwork(request: any) {
        return BaseApi.put(`${baseUrl}social-network`, request);
    }

    static postFinancialPassword(request: any) {
        return BaseApi.post(`${baseUrl}financial-password`, request);
    }

    static putFinancialPassword(request: any) {
        return BaseApi.put(`${baseUrl}financial-password`, request);
    }

    static postApprovalProcessContract(request: any) {
        return BaseApi.post(`${baseUrl}approval-process/contract`, request);
    }

    static postApprovalProcessCompletedCadastro() {
        return BaseApi.post(`${baseUrl}approval-process/cadastro/completed`);
    }

    static putApprovalProcessCompleted(request: any) {
        return BaseApi.put(`${baseUrl}approval-process/completed`, request);
    }

    static putPersonal(request: any) {
        return BaseApi.put(`${baseUrl}personal`, request);
    }

    static putRoleTeamManager(request: any) {
        return BaseApi.put(`${baseUrl}role/team-manager`, request);
    }

    static patchAvatar(request: any): Promise<string> {
        return BaseApi.patch(`${baseUrl}avatar`, request);
    }

    static deleteRole(request: any) {
        return BaseApi.post(`${baseUrl}role`, request);
    }

    static addRole(request: any) {
        return BaseApi.post(`${baseUrl}role/new-role`, request);
    }

    static putRoleTeamManagerApproved(request: any) {
        return BaseApi.put(`${baseUrl}role/team-manager/approved`, request);
    }

    static patchTwoFactor(request: any) {
        return BaseApi.patch(`${baseUrl}two-factory`, request);
    }


    static getExistByUserName(userName: string) {
        return BaseApi.get<boolean>(`${baseUrl}exist/username/${userName}`);
    }

    static getApprovalProcess() {
        return BaseApi.get(`${baseUrl}approval-process`);
    }

    static getNetwork() {
        return BaseApi.get(`${baseUrl}network`);
    }

    static getNetworkList(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}network/list`);
    }

    static getNetworkFirst(): Promise<any[]> {
        return BaseApi.get(`${baseUrl}network/first`);
    }

    static getProfileToEdit(): Promise<UserProfileToEditVM> {
        return BaseApi.get(`${baseUrl}profile/edit`);
    }

    static getToProfileToManagerById(id: string) {
        return BaseApi.get(`${baseUrl}${id}/profile/manager`);
    }

    static getToTransfer(filter: string): Promise<any[]> {
        return BaseApi.get(`${baseUrl}transfer`, { params: { filter } });
    }

    static getToList(filter: string): Promise<any[]> {
        return BaseApi.get(`${baseUrl}list`, {
            params: { filter }
        });
    }

    static getAddress() {
        return BaseApi.get(`${baseUrl}address`);
    }
    
    static getSearch(search: string): Promise<any[]> {
        return BaseApi.get(`${baseUrl}search?search=${encodeURIComponent(search)}`);
    }

    static getToCreateBankAccount(): Promise<any> {
        return BaseApi.get(`${baseUrl}bank/account`);
    }

    static getTwoFactorEnable(): Promise<any> {
        return BaseApi.get(`${baseUrl}two-factory/enable`);
    }

    static getSaldoEcash(): Promise<any> {
        return BaseApi.get(`${baseUrl}getEcash`);
    }

    static paymentEvent(request: any) {
        return BaseApi.post(`${baseUrl}paymentEvent`, request);
    }
 
    static searchAutoComplete(filter: string, type?: string): Promise<any[]> {
        if(filter.length < 3) {
            return Promise.resolve([]);
        }
        let typeParam = type ?? 'fullName';
        switch (type) {
            case 'name':
                typeParam = 'fullName';
                break;
            case 'cellPhone':
                typeParam = 'phone';
                break;
        };

        return BaseApi.get(`${baseUrl}autocomplete`, { params: { filter, type: typeParam }});
    }

    static getAutoCompleteById(id: string): Promise<AutoCompleteResponse> {
        return BaseApi.get(`${baseUrl}autocomplete/byId`, { params: { id }});
    }

    static getTokensNotification(): Promise<any> {
        return BaseApi.get(`${baseUrl}tokensNotification`);
    }
    static deleteTokensNotification(id: number): Promise<any> {
        return BaseApi.delete(`${baseUrl}tokensNotification/${id}`);
    }
    static getUserTokenCheckAccess(): Promise<any> {
        return BaseApi.get(`${baseUrl}TokenAccess`);
    }

    static putAprovalUser(request: any) {
        return BaseApi.put(`${baseUrl}AprovalUser`, request);
    }

    static getTokenAccessById(id: string): Promise<AutoCompleteResponse> {
        return BaseApi.get(`${baseUrl}GetTokenAccessById/${id}`);
    }
    static getMyUser(): Promise<AutoCompleteResponse> {
        return BaseApi.get(`${baseUrl}MyUser`);
    }
    static getCheckAccessAuthorizedStore(): Promise<boolean> {
        return BaseApi.get(`${baseUrl}CheckAccessAuthorizedStore`);
    }
    static GetUsersAccessAuthorizedStore(): Promise<any> {
        return BaseApi.get(`${baseUrl}GetUsersAccessAuthorizedStore`);
    }
    static PostUsersAccessAuthorizedStore(request: any): Promise<any> {
        return BaseApi.post(`${baseUrl}UsersAccessAuthorizedStore`, request);
    }
    static DeleteUserAccessAuthorizedStore(id: number | null): Promise<any> {
    return BaseApi.delete(`${baseUrl}UsersAccessAuthorizedStore/${id}`);
}
}

export default UserService;
